import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

const RevaluationSubsectionStep2 = ({fields, isSimulationLoading, simulationData}) => {  
  const [debitList, setDebitList] = useState([]);
  const [creditList, setCreditList] = useState([]);
  useEffect(() => {
    if (!simulationData) return;    
    setDebitList(simulationData?.accountingLines.filter(el => el.debit["EUR"] > 0));
    setCreditList(simulationData?.accountingLines.filter(el => el.credit["EUR"] > 0));
  }, [simulationData]);
  
  return isSimulationLoading ? 
    <div 
      style={{display: "flex", 
        alignItems: "center",
        width: "100%",
        justifyContent: "center"}}>
      <FontAwesomeIcon
        icon={["far", "circle-notch"]}
        spin
        style={{
          fontSize: "40px",
          color: "#1890ff"
        }}
      />
    </div>
    :(
      <div>
        <div className="pre-cog-assets-drawer-titles" style={{ marginTop: "40px" }}>
          <FormattedMessage id="preCog.assetsTab.drawer.fixedAsset" /> 
        </div>
        <div>
          <FormattedMessage id="preCog.assetsTab.drawer.movements.causalAccounting" />:
          <span className="precog-withholding-drawer-form—label-text"> ({simulationData?.reasonId})</span>
        </div>
        <div style={{display: "flex", justifyContent: "space-between", marginTop: "16px"}}>
          <div style={{width: "50%",paddingRight: "16px"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.accountingAccount" />
              </div>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.give" />
              </div>
            </div>
            {debitList.map((row,index) => 
              <div key={index} style={{display: "flex", justifyContent: "space-between"}}>
                <div style={{width: "70%"}}>{row?.accountDesc}</div>
                <div>{numeral(row.debit["EUR"]).format("0,0.00")} €</div>
              </div>)}
          </div>
          <div className={"pre-cog-assets-drawer-hr-vertical"} >&nbsp;</div>
          <div style={{width: "50%",paddingLeft: "16px"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.accountingAccount" />
              </div>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.have" />
              </div>
            </div>
            {creditList.map((row,index) => 
              <div key={index} style={{display: "flex", justifyContent: "space-between"}}>
                <div style={{width: "70%"}}>{row?.accountDesc}</div>
                <div>{numeral(row.credit["EUR"]).format("0,0.00")} €</div>
              </div>)}
          </div>
        </div>
      </div>
    );
};

export default RevaluationSubsectionStep2;